export default __webpack_public_path__ + "static/media/newDownload.639da6c4.svg";